import React from "react";
import { LoadioAlbumTrackListTemplate } from "themes/administration/loadio/pages";
import { LoadioAlbumTrackListViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new LoadioAlbumTrackListViewStore(rootStore, componentProps),
    "loadioAlbumTrackListViewStore"
)
class LoadioAlbumTrackList extends React.Component {
    render() {
        return <LoadioAlbumTrackListTemplate {...this.props} />;
    }
}

export default LoadioAlbumTrackList;
